/**
 * Maps an archive snapshot onto the models the collection views already use, so an
 * archived submission renders through the same bookmark grid and Works Cited table as
 * a live collection instead of a parallel set of components.
 *
 * Snapshot rows keep their own identifiers (archiveSourceID_ids), which are unrelated
 * to live collectionSource IDs — nothing here may be fed to the live source APIs.
 */

/** Collection-source rows for the bookmarks grid. */
export const mapSnapshotSources = (snapshot) => {
  const header = snapshot?.header || null;
  const sources = snapshot?.sources || [];
  const citations = snapshot?.citations || [];
  const notes = snapshot?.notes || [];

  return sources.map((source) => {
    const citation =
      citations.find(
        (item) => item.archiveSourceID_lng === source.archiveSourceID_ids
      ) || null;
    const sourceNotes = notes.filter(
      (item) => item.archiveSourceID_lng === source.archiveSourceID_ids
    );

    return {
      collectionSourceID_ids: source.archiveSourceID_ids,
      title_chr: source.title_chr,
      sourceName_chr: source.sourceName_chr,
      sourceUrl_chr: source.sourceUrl_chr,
      sourcePublishedDateTime_dtm: source.sourcePublishedDateTime_dtm,
      createdDateTime_dtm: header?.submittedDateTime_dtm ?? null,
      isCitationAvailable_ysn: Boolean(source.isCitationAvailable_ysn),
      isSummaryAvailable_ysn: Boolean(source.summary_chr),
      isReadingLevelAvailable_ysn: Boolean(source.articleComprehension_chr),
      readingLevel_chr: source.articleComprehension_chr ?? null,
      readingLevelName_chr: source.comprehensionLevel_chr ?? null,
      notesCount_cnt: sourceNotes.length,
      collectionMemberships: [],
      summary_chr: source.summary_chr,
      // Carried along so the sidebar reads the frozen copy rather than fetching.
      citation,
      notes: sourceNotes,
    };
  });
};

/** Works Cited documents, shaped for the Works Cited table. */
export const mapSnapshotWorkCited = (snapshot) => {
  const header = snapshot?.header || null;
  const workCited = snapshot?.workCited || [];
  const workCitedSources = snapshot?.workCitedSources || [];

  return workCited.map((entry) => ({
    workCitedId_ids: entry.archiveWorkCitedID_ids,
    name_chr: entry.name_chr,
    formatStyle_chr: entry.formatStyle_chr,
    citation_mem: entry.citation_mem,
    citationCount: workCitedSources.filter(
      (link) => link.archiveWorkCitedID_lng === entry.archiveWorkCitedID_ids
    ).length,
    lastUpdatedDateTime_dtm: header?.archivedDateTime_dtm ?? null,
  }));
};
